import styled from 'styled-components';

const ActiveMenu = styled.div`
    width: 2px;
    border-radius: 40px;
    background: #EBECF0;
    position: absolute;
    left: -12px;
    top: 0;
    height: 40px;
`;

export default ActiveMenu;